import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import { useStaff } from '@hooks';

import { MeetTheTeamContainer } from './styles';

const images = {
  matthew_baker: (
    <StaticImage
      src="../../images/staff/matthew-baker.jpg"
      alt="Matthew Baker"
    />
  ),
  bobbie_owen: (
    <StaticImage src="../../images/staff/bobbie-owen.jpg" alt="Bobbie Owen" />
  ),
  brianna_moloney: (
    <StaticImage
      src="../../images/staff/brianna-moloney.jpg"
      alt="Brianna Maloney"
    />
  ),
  emily_templeman: (
    <StaticImage
      src="../../images/staff/emily-templeman.jpg"
      alt="Emily Templeman"
    />
  ),
  emily_wall: (
    <StaticImage src="../../images/staff/emily-wall.jpg" alt="Emily Wall" />
  ),
  luke_pearcy: (
    <StaticImage src="../../images/staff/luke-pearcy.jpg" alt="Luke Pearcy" />
  ),
  michelle_wright: (
    <StaticImage
      src="../../images/staff/michelle-wright.jpg"
      alt="Michelle Wright"
    />
  ),
  pat_oshea: (
    <StaticImage src="../../images/staff/pat-oshea.jpg" alt="Pat O'Shea" />
  ),
  raymond_koen: (
    <StaticImage src="../../images/staff/raymond-koen.jpg" alt="Raymond Koen" />
  ),
  sharee_yauga: (
    <StaticImage
      src="../../images/staff/sharee-yuanga.jpg"
      alt="Sharee Yuanga"
    />
  ),
  mia_gamero: (
    <StaticImage src="../../images/staff/mia-gamero.jpg" alt="Mia Gamero" />
  ),
  caitlin_barling: (
    <StaticImage
      src="../../images/staff/caitlin-barling.jpg"
      alt="Caitlin Barling"
    />
  ),
  amelie_golds: (
    <StaticImage src="../../images/staff/amelie-golds.jpg" alt="Amelie Golds" />
  ),
  emma_fitzgerald: (
    <StaticImage
      src="../../images/staff/emma-fitzgerald.jpg"
      alt="Emma Fitzgerald"
    />
  ),
  ariella_paled: (
    <StaticImage
      src="../../images/staff/ariella-paled.jpg"
      alt="Ariella Paled"
    />
  ),
  stella_baker: (
    <StaticImage src="../../images/staff/stella-baker.jpg" alt="Stella Baker" />
  ),
  nicole_george: (
    <StaticImage
      src="../../images/staff/nicole-george.jpg"
      alt="Nicole George"
    />
  ),
  morgan_bartle: (
    <StaticImage
      src="../../images/staff/morgan-bartle.jpg"
      alt="Morgan Bartle"
    />
  ),
  sam_baker: (
    <StaticImage src="../../images/staff/sam-baker.jpg" alt="Sam Baker" />
  ),
  clara_hajj: (
    <StaticImage src="../../images/staff/clara-hajj.jpg" alt="Clara Hajj" />
  ),
};

const MeetTheTeam = () => {
  const items = useStaff();

  return (
    <MeetTheTeamContainer className="meet_the_team">
      <h2 className="meet_the_team__heading">Meet the Team</h2>
      <div className="meet_the_team__grid">
        {items.map(({ email, name, position, phone }, index) => {
          const imageKey = name
            .trim()
            .toLowerCase()
            .replaceAll(' ', '_')
            .replaceAll("'", '') as keyof typeof images;

          return (
            <div className="meet_the_team__member" key={index}>
              {images[imageKey]}
              <h3>{name}</h3>
              <h4>{position}</h4>
              <p>{email}</p>
              {phone !== '07 0000 0000' && (
                <p>
                  <a href={`tel:${phone}`}>{phone}</a>
                </p>
              )}
            </div>
          );
        })}
      </div>
    </MeetTheTeamContainer>
  );
};

export { MeetTheTeam };
